// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

// 引入ELEMENT
import ElementUI from 'element-ui'
Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css'

// 引入图标库
import '../static/icon/iconfont.css'

// 引入公共样式库
import '../static/common.css'

// 引入FILTER
import filters from '../src/utils/filter'
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

// 引入全局配置
import config from '../src/utils/config'
Vue.prototype.$config = config.data

import router from './router'
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js